import { IGlobalTablesService } from '@common/interfaces/i-global-tables-service';
import { INomWebServicesJson } from '@common/interfaces/i-nom-web-services-json';

export class Path {
    public static nomWebServicesJson: INomWebServicesJson;
    public static globalTablesService: IGlobalTablesService;

    constructor(public fullPath: string) {}

    // TODO PROBABLY NEED TEMPLATE PATH GETTER
    public equals(fullPath2: string | Path): boolean {
        if (fullPath2 instanceof Path) {
            return this.fullPath === fullPath2.fullPath;
        }
        return this.fullPath === fullPath2;
    }

    public get isInCollection(): boolean {
        return this.fullPath.toUpperCase().indexOf('\\R_', 0) > -1;
    }

    public get isUserPath(): boolean {
        return this.fullPath.toUpperCase().substring(0, 2) === 'U_';
    }

    public get groupId(): string {
        const iGroupPos = this.fullPath.indexOf('\\P_');
        if (iGroupPos > -1) {
            return this.fullPath.substring(iGroupPos + 3, this.fullPath.indexOf('\\', iGroupPos + 1));
        }

        return this.fullPath.substring(2, this.fullPath.indexOf('\\'));
    }

    public get isEventPath(): boolean {
        return this.fullPath.toUpperCase().indexOf('\\F_EVENTS', 0) > -1;
    }

    public get isSubFolder(): boolean {
        return this.fullPath.split('\\').length > 2;
    }

    public get isEmpty(): boolean {
        return !(this.fullPath !== null && this.fullPath.length > 0);
    }

    public get isHomePath(): boolean {
        const rootHomePath = `P_${Path.nomWebServicesJson.UserId.toUpperCase()}`;
        return this.fullPath.toUpperCase().slice(0, rootHomePath.length) === rootHomePath;
    }

    public get isTeamView(): boolean {
        const groupID = this.groupId;
        for (const group of Path.globalTablesService.PlaybookTeamsArray) {
            if (group.ID === groupID) {
                return true;
            }
        }
        return false;
    }

    public get isEnterpriseView(): boolean {
        const groupID = this.groupId;
        if (groupID === Path.globalTablesService.EnterprisePlaybookGroup) {
            return true;
        }
        return false;
    }

    public get isOwnView(): boolean {
        const userPath = `U_${Path.nomWebServicesJson.UserId.toUpperCase()}`;
        return this.fullPath.toUpperCase().slice(0, userPath.length) === userPath;
    }

    public get isWasteBinPath(): boolean {
        return this.fullPath.toUpperCase().indexOf('\\T', 0) > -1;
    }

    public get isMessagePath(): boolean {
        return this.fullPath.toUpperCase().indexOf('\\M', 0) > -1;
    }

    public get isContactPath(): boolean {
        return this.fullPath.toUpperCase().indexOf('CONTACTS', 0) > -1;
    }

    public get isSearchPath(): boolean {
        return this.fullPath.toUpperCase().indexOf('SEARCH', 0) > -1;
    }

    public get wasteBinName(): string {
        return this.fullPath.substring(0, 8);
    }

    public get contactsName(): string {
        return this.fullPath.substring(0, 8);
    }

    public get searchName(): string {
        return this.fullPath.substring(0, 6);
    }

    public get parentCollectionGuid(): string {
        const iPosSplit = this.fullPath.indexOf('R_');
        if (iPosSplit > -1) {
            return this.fullPath.toUpperCase().substring(iPosSplit + 2);
        }
    }

    public get parentCollectionPath(): Path {
        const iPosSplit = this.fullPath.indexOf('R_');
        if (iPosSplit > -1) {
            // Stripping last '\' as it was breaking clone/duplicate
            return new Path(this.fullPath.toUpperCase().substring(0, iPosSplit - 1));
        }
    }

    public get folderName(): string {
        const chunks = this.fullPath.split('\\');
        return chunks[chunks.length - 1].substring(2);
    }

    public get parentPath(): string {
        const chunks = this.fullPath.split('\\');
        let ret = '';
        for (let i = 0; i < chunks.length - 1; i++) {
            if (i > 0) ret += '\\';
            ret += chunks[i];
        }
        return ret;
    }

    public deepCopy(): Path {
        return new Path(this.fullPath);
    }
}
